module.exports = __webpack_public_path__ + "static/media/fabindia.28fc7e0b.jpg";